exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.newsBox[data-v-43120e4b] {\n    width: 100%;\n    margin-top: 0;\n}\n.newsBox .bannerBox[data-v-43120e4b] {\n      width: 100%;\n      height: auto;\n}\n.leftBox[data-v-43120e4b] {\n    width: 100%;\n    margin-top: 0;\n}\n.rightBox[data-v-43120e4b] {\n    display: none;\n}\n}\n", ""]);

